import { useQuery } from '@tanstack/react-query';
import { UserListService } from '../services/userList.service';
import type { UserFilters } from '../types/userList.types';
import { useState } from 'react';

export function useUserList(companyId: string, initialFilters: UserFilters = {}) {
 const [filters, setFilters] = useState<UserFilters>(initialFilters);

 const usersQuery = useQuery({
 queryKey: ['users-list', companyId, filters],
 queryFn: () => UserListService.getUsers(companyId, filters),
 enabled: !!companyId,
 });

 const statsQuery = useQuery({
 queryKey: ['users-list-stats', companyId],
 queryFn: () => UserListService.getUserStats(companyId),
 enabled: !!companyId,
 });

 return {
 users: usersQuery.data?.data || [],
 total: usersQuery.data?.total || 0,
 stats: statsQuery.data,
 isLoading: usersQuery.isLoading || statsQuery.isLoading,
 filters,
 setFilters,
 refetch: usersQuery.refetch
 };
}

export function useUserDetailQuick(id?: string) {
 return useQuery({
 queryKey: ['users-list-detail-quick', id],
 queryFn: () => UserListService.getUserDetail(id!),
 enabled: !!id,
 });
}

// Compatible hook for other modules
export function useUsers(companyId: string) {
 const query = useQuery({
 queryKey: ['users-list', companyId, {}],
 queryFn: () => UserListService.getUsers(companyId, {}),
 enabled: !!companyId,
 });

 return {
 ...query,
 data: query.data?.data || []
 };
}
